export default __webpack_public_path__ + "static/media/grinScopeLG.0550e2bc.png";